import { createSerializeWire } from '../../Serializable';
export class AttributeBaseModel {
    constructor() {
        this.serializeWire = createSerializeWire(this.serializeWireBase.bind(this));
    }
    serializeWireBase(writer) {
        writer.writeUInt8(this.usage);
    }
}

//# sourceMappingURL=AttributeBaseModel.js.map
